"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheGrowthArsenal() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const whiskeys = [{
    region: "AI AUTOMATION",
    name: "24/7 Answering",
    age: "Never Miss A Lead",
    notes: ["INSTANT", "ACCURATE", "PROFESSIONAL"],
    price: "STARTING",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_answering.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_answering.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_answering.webp-wvc-sizes"
  }, {
    region: "WEB DESIGN",
    name: "Premium Sites",
    age: "Built To Convert",
    notes: ["FAST", "RESPONSIVE", "MODERN"],
    price: "STARTING",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/web_design.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/web_design.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/web_design.webp-wvc-sizes"
  }, {
    region: "BRANDING",
    name: "Logo Creation",
    age: "Define Your Identity",
    notes: ["UNIQUE", "MEMORABLE", "PREMIUM"],
    price: "STARTING",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/logo_design.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/logo_design.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/logo_design.webp-wvc-sizes"
  }, {
    region: "OPERATIONS",
    name: "Booking Engine",
    age: "Automated Scheduling",
    notes: ["SEAMLESS", "SYNCED", "RELIABLE"],
    price: "STARTING",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/booking_engine.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/booking_engine.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/booking_engine.webp-wvc-sizes"
  }, {
    region: "SUPPORT",
    name: "Mission Success",
    age: "Veteran-Owned Care",
    notes: ["DEDICATED", "LOCAL", "TRUSTED"],
    price: "STARTING",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/client_support.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/client_support.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/client_support.png-wvc-sizes"
  }];
  return <section data-section-id="2747" id="the-growth-arsenal" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] max-w-3xl mx-auto">Tactical services to put your business on autopilot.</h2>
        </div>

        <div ref={gridRef} className={`mt-20 md:mt-24 lg:mt-28 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {whiskeys.slice(0, 3).map((whiskey, i) => <Card key={i} data-index={i} className={cn("group bg-card rounded-lg p-10 gap-0 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-lg border border-border", "mx-auto w-full")}>
                <div className="relative overflow-hidden rounded-lg mb-8" style={{
              aspectRatio: "4 / 5",
              background: "var(--secondary)"
            }}>
                  <img src={whiskey.image} data-wvc-srcset={whiskey.srcset} data-wvc-sizes={whiskey.sizes} alt={whiskey.name} loading="lazy" decoding="async" className="relative w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
                </div>
                <CardContent className="px-0">
                  <p className="font-mono text-[10px] tracking-[0.25em] mb-4 text-primary">
                    {whiskey.region}
                  </p>
                  <h3 className="font-default text-2xl md:text-[1.75rem] font-semibold leading-tight mb-2">
                    {whiskey.name}
                  </h3>
                  <p className="font-default text-base mb-6 text-muted-foreground">
                    {whiskey.age}
                  </p>
                  <div className="h-px w-full mb-6 bg-border" />
                  <div className="flex flex-wrap gap-2 mb-8">
                    {whiskey.notes.map((note, j) => <span key={j} data-index={j} className="inline-flex items-center px-3 py-1.5 rounded-md border text-[10px] font-mono tracking-[0.2em] border-border text-muted-foreground">
                        {note}
                      </span>)}
                  </div>
                </CardContent>
              </Card>)}
          </div>

          {}
          <div className="mt-8 lg:mt-10 flex flex-col md:flex-row justify-center gap-8 lg:gap-10">
            {whiskeys.slice(3).map((whiskey, i) => <Card key={i + 3} data-index={i + 3} className={cn("group bg-card rounded-lg p-10 gap-0 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-lg border border-border", "mx-auto md:mx-0 w-full md:max-w-[calc(50%-1rem)] lg:max-w-[calc(33.333%-1.67rem)]")}>
                <div className="relative overflow-hidden rounded-lg mb-8" style={{
              aspectRatio: "4 / 5",
              background: "var(--secondary)"
            }}>
                  <img src={whiskey.image} data-wvc-srcset={whiskey.srcset} data-wvc-sizes={whiskey.sizes} alt={whiskey.name} loading="lazy" decoding="async" className="relative w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
                </div>
                <CardContent className="px-0">
                  <p className="font-mono text-[10px] tracking-[0.25em] mb-4 text-primary">
                    {whiskey.region}
                  </p>
                  <h3 className="font-default text-2xl md:text-[1.75rem] font-semibold leading-tight mb-2">
                    {whiskey.name}
                  </h3>
                  <p className="font-default text-base mb-6 text-muted-foreground">
                    {whiskey.age}
                  </p>
                  <div className="h-px w-full mb-6 bg-border" />
                  <div className="flex flex-wrap gap-2 mb-8">
                    {whiskey.notes.map((note, j) => <span key={j} data-index={j} className="inline-flex items-center px-3 py-1.5 rounded-md border text-[10px] font-mono tracking-[0.2em] border-border text-muted-foreground">
                        {note}
                      </span>)}
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>

        <div ref={ctaRef} className={`mt-20 md:mt-24 text-center transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild variant="link" className="group font-mono text-xs tracking-[0.3em] p-0 h-auto hover:no-underline text-primary">
            <Link to="#">
              <span className="relative inline-block">
                VIEW ALL SOLUTIONS
                <span className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-0 bg-primary" />
                <span className="absolute left-0 -bottom-1 h-px w-full origin-right scale-x-0 transition-transform duration-500 delay-150 group-hover:scale-x-100 bg-primary" />
              </span>
              <ArrowRight className="ml-2 size-3 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}